import { render, staticRenderFns } from "./costoLaboral.vue?vue&type=template&id=c0590038&scoped=true"
import script from "./costoLaboral.vue?vue&type=script&lang=js"
export * from "./costoLaboral.vue?vue&type=script&lang=js"
import style0 from "./costoLaboral.vue?vue&type=style&index=0&id=c0590038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0590038",
  null
  
)

export default component.exports